/**
 * Shared display-name helpers that follow the Header UI language.
 */

const INDIVIDUAL_RE = /^Individual Sessions\s*-\s*(.+)$/i;
const WALK_IN_RE = /^Walk-in - Level #(.+)$/i;

export function studentDisplayName(name, id, t) {
  if (name && String(name).trim()) {
    const raw = String(name).trim();
    if (raw === '__UNKNOWN__') {
      return t('common.unknown', { defaultValue: 'Unknown' });
    }
    const sentinel = raw.match(/^__STUDENT__(\d+)$/);
    if (sentinel) {
      return t('attendance.studentFallback', { id: sentinel[1], defaultValue: `Student #${sentinel[1]}` });
    }
    return raw;
  }
  if (id == null || id === '') return t('common.unknown', { defaultValue: 'Unknown' });
  return t('attendance.studentFallback', { id, defaultValue: `Student #${id}` });
}

export function coachDisplayName(name, id, t) {
  if (name && String(name).trim()) return String(name).trim();
  if (id == null || id === '') return t('common.unknown', { defaultValue: 'Unknown' });
  return t('attendance.coachFallback', { id, defaultValue: `Coach #${id}` });
}

export function userDisplayName(name, id, t) {
  if (name && String(name).trim()) return String(name).trim();
  if (id == null || id === '') return t('common.unknown', { defaultValue: 'Unknown' });
  return t('common.userFallback', { id, defaultValue: `User #${id}` });
}

export function branchDisplayName(name, id, t) {
  if (name && String(name).trim()) return String(name).trim();
  if (id == null || id === '') return t('common.unknown', { defaultValue: 'Unknown' });
  return t('common.branchFallback', { id, defaultValue: `Branch #${id}` });
}

export function levelDisplayName(name, id, t) {
  if (name && String(name).trim()) return String(name).trim();
  if (id == null || id === '') return t('common.unknown', { defaultValue: 'Unknown' });
  return t('common.levelFallback', { id, defaultValue: `Level #${id}` });
}

/** Localize system batch names; keep real academy batch names as-is. */
export function localizeBatchName(name, t) {
  if (name == null || name === '') return name;
  const raw = String(name);
  if (raw === '__UNKNOWN_BATCH__' || /^unknown batch$/i.test(raw)) {
    return t('batches.unknown', { defaultValue: 'Unknown batch' });
  }
  if (/^individual sessions$/i.test(raw)) {
    return t('batches.individualSessions', { defaultValue: 'Individual Sessions' });
  }
  const individual = raw.match(INDIVIDUAL_RE);
  if (individual) {
    return t('batches.individualSessionsNamed', {
      level: individual[1].trim(),
      defaultValue: 'Individual Sessions - {{level}}',
    });
  }
  const walkIn = raw.match(WALK_IN_RE);
  if (walkIn) {
    return t('batches.walkInNamed', {
      level: walkIn[1].trim(),
      defaultValue: 'Walk-in - Level #{{level}}',
    });
  }
  return raw;
}

export function isIndividualSessionsBatch(name) {
  return typeof name === 'string' && (INDIVIDUAL_RE.test(name) || /^individual sessions$/i.test(name));
}
